import { publicClient, privateClient } from '../../configs/axiosConfig';
import menuEndpoints from './menuEndpoints.js';

// API liên quan đến người dùng
const menuApi = {
  // API đăng nhập
  getMenuCategoryByOperator: async (bussinessId) => {
    try {
      const response = await privateClient.post(menuEndpoints.getMenuCategoryByOperator, { operator: bussinessId });
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  getMenuItemsByCategory: async (categoryId) => {
    try {
      const response = await privateClient.post(menuEndpoints.getMenuItemsByCategory, { category: categoryId });
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  createCategoryMenu: async (categoryInfo) => {
    try {
      const response = await privateClient.post(menuEndpoints.createCategoryMenu, categoryInfo);
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  deleteCategoryMenu: async (categoryId) => {
    try {
      const response = await privateClient.post(menuEndpoints.deleteCategoryMenu, { id: categoryId });
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  updateCategoryMenu: async (categoryInfo) => {
    try {
      const response = await privateClient.post(menuEndpoints.updateCategoryMenu, categoryInfo);
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  createMenuItem: async (menuItemInfo) => {
    try {
      const response = await privateClient.post(menuEndpoints.createMenuItem, menuItemInfo);
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  updateMenuItem: async (menuItemInfo) => {
    try {
      const response = await privateClient.post(menuEndpoints.updateMenuItem, menuItemInfo);
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  },
  deleteMenuItem: async (menuItemId) => {
    try {
      const response = await privateClient.post(menuEndpoints.deleteMenuItem, { id: menuItemId });
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Login failed");
    }
  }
};

export default menuApi;